<template>
  <div class="login-service-list">
    <service-list :service-list="serviceList"></service-list>

    <feedback-service-dialog :visible.sync="feedbackVisible"></feedback-service-dialog>
  </div>
</template>

<script>
import ServiceList from './service-list/service-list.vue';
import PopoverFollowUs from './popover/popover-follow-us.vue';
import PopoverPhone from './popover/popover-phone';
import PopoverFeedback from './popover/popover-feedback';
import PopoverOnlineInquire from './popover/popover-online-inquire';
import FeedbackServiceDialog from './dialog/feedback-service-dialog.vue';

import wxaImage from '@/assets/imgs/homepage/fixed-right-service/service-follow-us.png';
import wxaActiveImage from '@/assets/imgs/homepage/fixed-right-service/service-follow-us-active.png';
import phoneImage from '@/assets/imgs/homepage/fixed-right-service/service-phone.png';
import phoneActiveImage from '@/assets/imgs/homepage/fixed-right-service/service-phone-active.png';
import feedbackImage from '@/assets/imgs/homepage/fixed-right-service/service-feedback.png';
import feedbackActiveImage from '@/assets/imgs/homepage/fixed-right-service/service-feedback-active.png';
import customerImage from '@/assets/imgs/homepage/fixed-right-service/service-customer.png';


export default {
  props: {},
  components: {
    ServiceList,
    PopoverPhone,
    PopoverFeedback,
    PopoverFollowUs,
    PopoverOnlineInquire,
    FeedbackServiceDialog,
  },
  data() {
    return {
      serviceList: [
        {
          name: '电话',
          defaultImage: phoneImage,
          hoverImage: phoneActiveImage,
          popover: PopoverPhone,
        },
        {
          name: '反馈',
          defaultImage: feedbackImage,
          hoverImage: feedbackActiveImage,
          popover: PopoverFeedback,
          clickHandler: () => this.openFeedBackDialog(),
        },
        {
          name: '小程序',
          defaultImage: wxaImage,
          hoverImage: wxaActiveImage,
          popover: PopoverFollowUs,
        },
        {
          name: '在线咨询',
          defaultImage: customerImage,
          imgKey: 'wwx_avatar',
          type: 'hotline',
          popover: PopoverOnlineInquire,
        },
      ],
      // feedback
      feedbackVisible: false,
    };
  },
  methods: {
    openFeedBackDialog() {
      this.feedbackVisible = true;
    },
  },
};
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/components/fixed-right-service/components/login-service-list.vue